import type { SVGProps } from 'react';

export const ShareTriggerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 458.624 458.624"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M339.588 314.529c-14.215 0-27.456 4.133-38.621 11.239l-112.682-78.67c1.809-6.315 2.798-12.976 2.798-19.871s-.989-13.557-2.798-19.871l109.64-76.547c11.764 8.356 26.133 13.286 41.662 13.286 39.79 0 72.047-32.257 72.047-72.047C411.634 32.258 379.378 0 339.588 0c-39.79 0-72.047 32.257-72.047 72.047 0 5.255.578 10.373 1.646 15.308l-112.424 78.491c-10.974-6.759-23.892-10.666-37.727-10.666-39.79 0-72.047 32.257-72.047 72.047s32.256 72.047 72.047 72.047c13.834 0 26.753-3.907 37.727-10.666l113.292 79.097c-1.629 6.017-2.514 12.34-2.514 18.872 0 39.79 32.257 72.047 72.047 72.047 39.79 0 72.047-32.257 72.047-72.047 0-39.79-32.257-72.048-72.047-72.048" />
  </svg>
);

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1024 1024"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z" />
    <path d="M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z" />
  </svg>
);

export const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 26 21"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M1 5.16675L11.5208 12.1806C12.4165 12.7778 13.5835 12.7778 14.4792 12.1806L25 5.16675M3.66667 19.8334H22.3333C23.8061 19.8334 25 18.6395 25 17.1667V3.83341C25 2.36066 23.8061 1.16675 22.3333 1.16675H3.66667C2.19391 1.16675 1 2.36066 1 3.83341V17.1667C1 18.6395 2.19391 19.8334 3.66667 19.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 48 48"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M44.9 23.2l-38-18L6 5A2 2 0 0 0 4 7l5.3 16H24a2.1 2.1 0 0 1 2 2 2 2 0 0 1-2 2H9.3L4 43a2 2 0 0 0 2 2l.9-.2 38-18a2 2 0 0 0 0-3.6" />
  </svg>
);

export const XIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1200 1227"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
  </svg>
);

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false" {...props}>
    <path
      d="M449.446 0c34.525 0 62.554 28.03 62.554 62.554v386.892c0 34.524-28.03 62.554-62.554 62.554H342.978V319.085h66.6l12.672-82.621h-79.272v-53.617c0-22.603 11.073-44.636 46.58-44.636h36.042v-70.34s-32.71-5.582-63.982-5.582c-65.288 0-107.96 39.569-107.96 111.204v62.971h-72.573v82.621h72.573V512H62.554C28.03 512 0 483.97 0 449.446V62.554C0 28.03 28.029 0 62.554 0z"
      fill="#1777f2"
    />
  </svg>
);

export const InstagramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false" {...props}>
    <defs>
      <linearGradient
        id="sharelinks-instagram-1"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientTransform="matrix(-149.618,494.3,-494.3,-149.618,300.81,-27.1283)"
      >
        <stop offset="0" stopColor="#515bd4" />
        <stop offset="0.26" stopColor="#9510b8" />
        <stop offset="0.66" stopColor="#e51804" />
        <stop offset="1" stopColor="#feda77" />
      </linearGradient>
      <linearGradient
        id="sharelinks-instagram-2"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientTransform="matrix(-149.618,494.3,-494.3,-149.618,300.81,-27.1283)"
      >
        <stop offset="0" stopColor="#515bd4" />
        <stop offset="0.26" stopColor="#9510b8" />
        <stop offset="0.66" stopColor="#e51804" />
        <stop offset="1" stopColor="#ffbf00" />
      </linearGradient>
      <linearGradient
        id="sharelinks-instagram-3"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientTransform="matrix(-149.618,494.3,-494.3,-149.618,300.81,-27.1283)"
      >
        <stop offset="0" stopColor="#515bd4" />
        <stop offset="0.26" stopColor="#9510b8" />
        <stop offset="0.66" stopColor="#e51804" />
        <stop offset="1" stopColor="#ffbf00" />
      </linearGradient>
    </defs>
    <g>
      <path
        d="M256 0c-69.526 0-78.244.295-105.549 1.541-27.248 1.243-45.858 5.57-62.142 11.899-16.834 6.542-31.111 15.296-45.342 29.528-14.232 14.231-22.986 28.508-29.528 45.342-6.329 16.283-10.656 34.893-11.899 62.141C.294 177.756 0 186.474 0 256c0 69.524.294 78.242 1.54 105.547 1.243 27.248 5.57 45.858 11.899 62.141 6.542 16.834 15.296 31.111 29.528 45.344 14.231 14.231 28.508 22.985 45.342 29.527 16.284 6.328 34.894 10.656 62.142 11.899C177.756 511.705 186.474 512 256 512c69.524 0 78.242-.295 105.547-1.54 27.248-1.243 45.858-5.571 62.141-11.899 16.834-6.542 31.111-15.296 45.344-29.527 14.231-14.233 22.985-28.51 29.527-45.344 6.328-16.283 10.656-34.893 11.899-62.141 1.245-27.305 1.54-36.023 1.54-105.547 0-69.526-.295-78.244-1.54-105.549-1.243-27.248-5.571-45.858-11.899-62.141-6.542-16.834-15.296-31.111-29.527-45.342-14.233-14.232-28.51-22.986-45.344-29.528-16.283-6.329-34.893-10.656-62.141-11.899C334.242.295 325.524 0 256 0Zm0 46.127c68.354 0 76.451.26 103.445 1.492 24.959 1.139 38.514 5.309 47.535 8.814 11.949 4.644 20.477 10.192 29.435 19.15 8.959 8.958 14.506 17.487 19.15 29.435 3.506 9.021 7.676 22.576 8.815 47.535 1.231 26.995 1.492 35.092 1.492 103.447 0 68.354-.261 76.451-1.492 103.445-1.139 24.959-5.309 38.514-8.815 47.535-4.644 11.949-10.191 20.477-19.15 29.435-8.958 8.959-17.486 14.506-29.435 19.15-9.021 3.506-22.576 7.676-47.535 8.814-26.99 1.232-35.086 1.493-103.445 1.493-68.361 0-76.455-.261-103.447-1.493-24.959-1.138-38.514-5.308-47.535-8.814-11.949-4.644-20.477-10.191-29.436-19.15-8.958-8.958-14.506-17.486-19.149-29.435-3.506-9.021-7.676-22.576-8.815-47.535-1.232-26.994-1.492-35.091-1.492-103.445 0-68.355.26-76.452 1.492-103.447 1.139-24.959 5.309-38.514 8.815-47.535 4.643-11.948 10.191-20.477 19.149-29.435 8.959-8.958 17.487-14.506 29.436-19.15 9.021-3.505 22.576-7.675 47.535-8.814 26.995-1.232 35.092-1.492 103.447-1.492Z"
        fill="url(#sharelinks-instagram-1)"
        fillRule="nonzero"
      />
      <path
        d="M256 341.332c-47.129 0-85.334-38.205-85.334-85.332 0-47.129 38.205-85.334 85.334-85.334 47.127 0 85.332 38.205 85.332 85.334 0 47.127-38.205 85.332-85.332 85.332Zm0-216.792c-72.604 0-131.46 58.856-131.46 131.46 0 72.602 58.856 131.458 131.46 131.458 72.602 0 131.458-58.856 131.458-131.458 0-72.604-58.856-131.46-131.458-131.46Z"
        fill="url(#sharelinks-instagram-2)"
        fillRule="nonzero"
      />
      <path
        d="M423.372 119.346c0 16.967-13.754 30.72-30.72 30.72-16.966 0-30.72-13.753-30.72-30.72 0-16.966 13.754-30.719 30.72-30.719 16.966 0 30.72 13.753 30.72 30.719Z"
        fill="url(#sharelinks-instagram-3)"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
